export default __webpack_public_path__ + "static/media/empty-courses.e7e5c742.png";